import React from 'react';

import b_ from 'b_';

import AddIcon from './icons/add.svg';
import RemoveIcon from './icons/remove.svg';

import {ItemProps} from './types';

import './item.css';

const b = b_.with('preset-description');

export default function Item(props: ItemProps) {
    const {onClick, label, theme} = props;

    return (
        <div className={b('item', {theme, clickable: Boolean(onClick)})} onClick={onClick}>
            <span className={b('item-label')}>{label}</span>
            <div className={b('item-icons')}>
                {theme === 'picked' && (
                    <img className={b('icon', {type: 'remove'})} src={RemoveIcon} />
                )}
                {theme === 'unused' && <img className={b('icon', {type: 'add'})} src={AddIcon} />}
            </div>
        </div>
    );
}
